// @flow
import React from 'react'
import type { Topic } from 'types/www/topic'
import OneColumnSpecialItem from 'components/molecules/TopicContentItem/OneColumnSpecial'
import OneColumnItem from 'components/molecules/TopicContentItem/OneColumn'
import ThreeColumnItem from 'components/molecules/TopicContentItem/ThreeColumn'
import ThreeColumnSpaceItem from 'components/molecules/TopicContentItem/ThreeColumnSpace'
import FourColumnItem from 'components/molecules/TopicContentItem/FourColumn'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'
import Const from 'common/consts'
import Path from 'routes/path'
import { accountSignUpUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  topic: Topic,
}

export default class TopicPage extends React.Component<*> {
  props: PropTypes

  renderSocialLink(topic) {
    const { topicPath } = this.props
    return (
      <ul className="topics__social">
        <li className="topics__social-item">
          <a
            href={`https://twitter.com/intent/tweet?url=https://www.spacemarket.com${topicPath}&text=${
              topic.title
            }`}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link__twitter"
          >
            <i className="fa fa-twitter" />
          </a>
        </li>
        <li className="topics__social-item">
          <a
            href={`http://www.facebook.com/sharer/sharer.php?u=https://www.spacemarket.com${topicPath}&t=${
              topic.title
            }`}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link__facebook"
          >
            <i className="fa fa-facebook-square" />
          </a>
        </li>
        <li className="topics__social-item">
          <a
            href={`javascript:window.open('http://getpocket.com/edit?url=https://www.spacemarket.com${topicPath}&title=${
              topic.title
            }','_blank','width=400,height=460')`}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link__pocket"
          >
            <i className="fa fa-get-pocket" />
          </a>
        </li>
        <li className="topics__social-item">
          <a
            href={`http://line.me/R/msg/text/?${encodeURIComponent(
              `${topic.title} https://www.spacemarket.com${topicPath}`,
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link__line"
          >
            <i className="icon icon-spm-line" />
          </a>
        </li>
      </ul>
    )
  }

  renderRegist() {
    const currentUser = this.props.currentUser
    if (currentUser) {
      return (
        <div className="page__stripes top-page__padding">
          <div className="container">
            <div className="top-more__area top-flow__regist">
              <div className="top-bonus__points">
                <p className="top-bonus__points-inner">
                  {i18n.t('referral.campaign')}
                </p>
              </div>
              <h2 className="top-flow__referral-title">
                {i18n.t('referral.title')}
                <br />
                <span>{i18n.t('referral.subTitle')}</span>
              </h2>
              <a
                href={Path.referrals()}
                className="button-blue top-flow__regist-button"
              >
                {i18n.t('referral.button')}
              </a>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="stripe-regist">
          <div className="top-more__area stripe-regist__container">
            <div className="stripe-regist__unit">
              <p className="stripe-regist__title-guide">
                {i18n.t('regist.titleGuide')}
              </p>
              <div className="stripe-regist__present">
                <p className="stripe-regist__everyone">
                  <span>{i18n.t('regist.everyone')}</span>
                </p>
                <h2 className="stripe-regist__title">
                  <span className="stripe-regist__title-large">
                    <span className="stripe-regist__title-medium">¥</span>
                    {i18n.t('regist.price')}
                  </span>
                  <span className="stripe-regist__title-small">
                    {i18n.t('regist.title')}
                    <br />
                  </span>
                </h2>
              </div>
            </div>
            <div className="stripe-regist__text">{i18n.t('regist.text')}</div>
            <div className="stripe-regist__button_wrap">
              <a
                href={accountSignUpUrl()}
                className="btn__large btn__style bg_blue"
              >
                {i18n.t('regist.button')}
              </a>
            </div>
          </div>
        </div>
      )
    }
  }

  render() {
    const topic = this.props.topic
    const topicContents = this.props.topic.topicContents.results

    let topicContentsSection = []

    topicContents.map(topicContent => {
      let topicContentsSectionItem = []
      const topicContentItems = topicContent.topicContentItems.results
      const contentIndex = topicContent.id

      switch (topicContent.titleDecoration) {
        case Const.TitleDecoration.TitleLevel1:
          topicContentsSection.push(
            <h2 key={contentIndex} className="topics__ttl-level1">
              <span>{topicContent.title}</span>
            </h2>,
          )
          break

        case Const.TitleDecoration.TitleLevel2:
          topicContentsSection.push(
            <h3 key={contentIndex} className="topics__ttl-level2">
              {topicContent.title}
            </h3>,
          )
          break

        case Const.TitleDecoration.TitleLevel3:
          topicContentsSection.push(
            <h4 key={contentIndex} className="topics__ttl-level3">
              {topicContent.title}
            </h4>,
          )
          break
      }

      // リード文の数に応じて改行を追加する
      if (topicContent.leadStatement3) {
        topicContentsSection.push(
          <p key={contentIndex + '-text'} className="topics__commontext">
            {topicContent.leadStatement}
            <br />
            {topicContent.leadStatement2}
            <br />
            {topicContent.leadStatement3}
          </p>,
        )
      } else if (topicContent.leadStatement2) {
        topicContentsSection.push(
          <p key={contentIndex + '-text'} className="topics__commontext">
            {topicContent.leadStatement}
            <br />
            {topicContent.leadStatement2}
          </p>,
        )
      } else {
        topicContentsSection.push(
          <p key={contentIndex + '-text'} className="topics__commontext">
            {topicContent.leadStatement}
          </p>,
        )
      }

      switch (topicContent.contentType) {
        case Const.TopicContentType.OneColumnSpecial:
          topicContentItems.map(topicContentItem => {
            topicContentsSectionItem.push(
              <OneColumnSpecialItem
                title={topicContentItem.title}
                content={topicContentItem.content}
                image={topicContentItem.image}
                buttonTitle={topicContentItem.buttonTitle}
                linkUrl={topicContentItem.linkUrl}
                key={topicContentItem.id}
              />,
            )
          })
          topicContentsSection.push(
            <ul
              key={contentIndex + '-item'}
              className="topics__biglist-special"
            >
              {topicContentsSectionItem}
            </ul>,
          )
          break

        case Const.TopicContentType.OneColumn:
          topicContentItems.map(topicContentItem => {
            topicContentsSectionItem.push(
              <OneColumnItem
                title={topicContentItem.title}
                content={topicContentItem.content}
                image={topicContentItem.image}
                buttonTitle={topicContentItem.buttonTitle}
                linkUrl={topicContentItem.linkUrl}
                key={topicContentItem.id}
              />,
            )
          })
          topicContentsSection.push(
            <ul key={contentIndex + '-item'} className="topics__biglist">
              {topicContentsSectionItem}
            </ul>,
          )
          break

        case Const.TopicContentType.ThreeColumn:
          topicContentItems.map(topicContentItem => {
            topicContentsSectionItem.push(
              <ThreeColumnItem
                title={topicContentItem.title}
                content={topicContentItem.content}
                image={topicContentItem.image}
                buttonTitle={topicContentItem.buttonTitle}
                linkUrl={topicContentItem.linkUrl}
                key={topicContentItem.id}
              />,
            )
          })
          topicContentsSection.push(
            <ul key={contentIndex + '-item'} className="topics__mediumlist">
              {topicContentsSectionItem}
            </ul>,
          )
          break

        case Const.TopicContentType.ThreeColumnSpace:
          topicContentItems.map(topicContentItem => {
            topicContentsSectionItem.push(
              <ThreeColumnSpaceItem
                title={topicContentItem.title}
                content={topicContentItem.content}
                image={topicContentItem.image}
                linkUrl={topicContentItem.linkUrl}
                priceText={topicContentItem.priceText}
                capacity={topicContentItem.capacity}
                area={topicContentItem.area}
                key={topicContentItem.id}
              />,
            )
          })
          topicContentsSection.push(
            <ul
              key={contentIndex + '-item'}
              className="topics__mediumlist-space"
            >
              {topicContentsSectionItem}
            </ul>,
          )
          if (
            topicContent.linkUrl.length > 0 &&
            topicContent.buttonTitle.length > 0
          ) {
            topicContentsSection.push(
              <p
                key={contentIndex + '-button'}
                className="mediumlist-space__link"
              >
                <a
                  href={topicContent.linkUrl}
                  className="textlink-arrow cl_blue"
                >
                  {topicContent.buttonTitle}
                </a>
              </p>,
            )
          }
          break

        case Const.TopicContentType.FourColumn:
          topicContentItems.map(topicContentItem => {
            topicContentsSectionItem.push(
              <FourColumnItem
                title={topicContentItem.title}
                image={topicContentItem.image}
                linkUrl={topicContentItem.linkUrl}
                key={topicContentItem.id}
              />,
            )
          })
          topicContentsSection.push(
            <ul key={contentIndex + '-item'} className="topics__smalllist">
              {topicContentsSectionItem}
            </ul>,
          )
          break
      }
    })

    const color = topic.themeColor
    const rgb_color =
      parseInt(color.slice(1, 3), 16) +
      ',' +
      parseInt(color.slice(3, 5), 16) +
      ',' +
      parseInt(color.slice(5, 7), 16)

    // 擬似要素 before, afterのスタイルはスタイルタグに直接書き込む必要があるため、ここで定義する
    let topicCss = `
      .topics__main-ttl .topics__main-subttl {
          color: ${color};
        }
      .topics__main-ttl .topics__main-subttl:before {
          background: ${color};
        }
      .topics__maintext {
          background: rgba(${rgb_color},0.1);
        }
      @media screen and (max-width: 767px) {
        .topics__mainimg-wrap {
            background: rgba(${rgb_color},0.1);
          }
        }
      @media screen and (max-width: 767px) {
        .topics__mainimg {
            box-shadow: 0 5px 0 ${color};
          }
        }
      @media screen and (min-width: 768px) {
        .topics__mainimg {
            box-shadow: 8px 8px 0 ${color};
          }
        }
      .topics__ttl-level2 {
          background: ${color};
        }

      .biglist__img:after {
          background: ${color};
        }
      .ribbon-top {
          background: ${color};
        }
      .ribbon-bottom {
          background: ${color};
        }
      .biglist-special__item {
          border: 3px solid ${color};
        }
      .mediumlist__spacename:after {
          background: ${color};
        }
      .smalllist__text {
          border-left: 2px solid ${color};
    }`

    const mainImageUrl = imageURLWithTransform(topic.image, {
      width: 1004,
      height: 480,
      crop: 'fill',
    })

    return (
      <div className="site-main">
        <style>{topicCss}</style>
        <article>
          <header className="topics__main">
            <h1 className="topics__main-ttl">
              <span className="topics__main-subttl">
                {i18n.t('page.topic.mainTitle')}
              </span>
              {topic.title}
            </h1>
            <div className="topics__maintop">
              <div className="topics__mainimg-wrap">
                <p className="topics__mainimg">
                  <OptimizedImage src={mainImageUrl} alt={topic.title} />
                </p>
                <p className="topics__mainimg-deco">
                  <OptimizedImage src={topic.subImage} />
                </p>
              </div>
              <div className="topics__maintext">
                <p>{topic.leadStatement}</p>
              </div>
            </div>
          </header>
          {this.renderSocialLink(topic)}
          <section className="topics__contents">{topicContentsSection}</section>
          {this.renderSocialLink(topic)}
        </article>
        {this.renderRegist()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/TopicPage/index.jsx